import Administrator from "./Administrator";
import Bid from "./Bids";
import BuyFigure from "./BuyFigure";
import Chat from "./Chat";
import ChromeData from "./ChromeData";
import AddContactUs from "./ContactUs";
import Dashboard from "./Dashboard";
import Dealer from "./Dealer";
import Inventory from "./Inventory";
import MyGarage from "./MyGarage";
import PrivateNetwork from "./PrivateNetwork";
import Products from "./Products";
import Quote from "./Quote";
import Reachout from "./ReachOut";
import RoleManagement from "./RoleManagement";
import Upload from "./Upload";
import Users from "./Users";

export default {
    AddContactUs,
    Dealer,
    RoleManagement,
    Chat,
    Administrator,
    Inventory,
    Bid,
    Users,
    Products,
    Dashboard,
    MyGarage,
    Reachout,
    BuyFigure,
    Quote,
    PrivateNetwork,
    ChromeData,
    Upload
};
